import { render, staticRenderFns } from "./number-scale.vue?vue&type=template&id=0ef46edd&scoped=true&"
import script from "./number-scale.vue?vue&type=script&lang=js&"
export * from "./number-scale.vue?vue&type=script&lang=js&"
import style0 from "./number-scale.vue?vue&type=style&index=0&id=0ef46edd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef46edd",
  null
  
)

component.options.__file = "number-scale.vue"
export default component.exports